import styled from "styled-components";

interface SelectionProps {
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.interfacePure0};
  padding: 8px;
  border-radius: 8px;
  overflow-x: hidden;
  box-sizing: border-box;

  .toasted {
    z-index: 99999;
  }

  .loader {
    margin: 0 auto;
  }

  .professionals-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    width: 100%;
  }

  .professionals-loader {
    margin: 0 auto;
  }

  @media (max-width: 1024px) {
    padding: 12px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 8px;
  }
`;

export const Line = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.interfacePure0};
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

export const SearchHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
  }

  .search {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 300px;
    max-width: 600px;
    height: 56px;
    padding: 0 16px;
    background: ${(props: any) => props.theme.colors.white};
    border-radius: 12px;
    margin-top: 26px;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
    transition: all 0.2s ease;
    
    &:focus-within {
      border-color: ${({ theme }) => theme.colors.primaryRed400};
      box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
    }
    
    @media (max-width: 1024px) {
      margin-top: 0;
      width: 100%;
      max-width: 300px;
      min-width: 200px;
      height: 52px;
      padding: 0 14px;
    }
    
    @media (max-width: 768px) {
      width: 100%;
      max-width: 100%;
      height: 48px;
      padding: 0 12px;
    }
    
    input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: 16px;
      color: ${(props: any) => props.theme.colors.interfaceText500};
      font-weight: 400;
      
      &::placeholder {
        color: ${(props: any) => props.theme.colors.interfaceText400};
        font-weight: 400;
      }
      
      @media (max-width: 768px) {
        font-size: 15px;
      }
    }

    .search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 6px;
    }

    .clean-search {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 6px;
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
      
      svg {
        path {
          fill: ${({ theme }) => theme.colors.interfaceText300};
        }
        &:hover {
          path {
            fill: ${({ theme }) => theme.colors.interfaceText500};
          }
        }
      }
    }        
  }

  .countie-status {
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    flex-shrink: 0;

    @media (max-width: 1024px) {
      width: 100%;
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.interfaceText400};
      white-space: nowrap;
      
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    .select {
      width: 300px;
      position: relative;
      display: inline-block;
      
      @media (max-width: 1024px) {
        width: 100%;
        max-width: 300px;
      }
      
      @media (max-width: 768px) {
        max-width: 100%;
      }

      .select-trigger {
        width: 100%;
        height: 56px;
        padding: 0 16px;
        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
        border-radius: 12px;
        background: ${(props: any) => props.theme.colors.white};
        color: ${(props: any) => props.theme.colors.interfaceText500};
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: border-color 0.15s ease;

        &:hover {
          border-color: ${({ theme }) => theme.colors.primaryRed400};
        }

        &:focus {
          border-color: ${({ theme }) => theme.colors.primaryRed400};
          box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
        }

        @media (max-width: 1024px) {
          height: 52px;
          padding: 0 14px;
        }

        @media (max-width: 768px) {
          height: 48px;
          padding: 0 12px;
          font-size: 15px;
        }

        .select-value {
          flex: 1;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .select-arrow {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 16px;
          height: 16px;
          margin-left: 8px;
          transition: none;

          svg {
            width: 100%;
            height: 100%;
            stroke: ${(props: any) => props.theme.colors.interfaceText400};
          }
        }

        &.open .select-arrow {
          transform: rotate(180deg);
        }
      }

      .select-dropdown {
        position: absolute;
        left: 0;
        right: 0;
        background: ${(props: any) => props.theme.colors.white};
        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        max-height: 300px;
        overflow-y: auto;
        z-index: 1000;
        min-width: 200px;

        &.below {
          top: 100%;
          margin-top: 4px;
        }

        &.above {
          bottom: 100%;
          margin-bottom: 4px;
        }

        @media (max-width: 768px) {
          max-height: 250px;
          min-width: 150px;
        }

        @media (max-width: 480px) {
          max-height: 200px;
          min-width: 120px;
          width: var(--dropdown-width, 100%);
          left: 0;
          right: auto;
        }

        .select-option {
          padding: 12px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 400;
          color: ${(props: any) => props.theme.colors.interfaceText500};
          border-bottom: 1px solid ${(props: any) => props.theme.colors.background};
          transition: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: ${(props: any) => props.theme.colors.background};
          }

          &.selected {
            background-color: ${(props: any) => props.theme.colors.ce3f2fd};
            color: ${({ theme }) => theme.colors.interfaceGray400};
            font-weight: 500;
          }

          @media (max-width: 768px) {
            padding: 10px;
            font-size: 14px;
          }
        }
      }
    }
  }
`;

export const ProfessionalTitles = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr 88px 88px 80px 48px;
  gap: 16px;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  margin-bottom: 8px;
  padding: 16px;
  overflow-x: auto;

  .icon-profile {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .name {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText400};
    min-width: 0;
  }

  .service {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText400};
    text-align: left;
    min-width: 88px;
  }

  .profit {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText400};
    text-align: center;
    min-width: 88px;

    &.negative {
      color: ${({ theme }) => theme.colors.primaryRed400};
    }
  }

  .code {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText400};
    text-align: center;
    min-width: 80px;
  }

  .contact {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 28px 1fr 70px 70px 70px 44px;
    gap: 12px;
    padding: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 24px 1fr 60px 60px 60px 40px;
    gap: 8px;
    padding: 8px;
    font-size: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 20px 1fr 50px 50px 50px 36px;
    gap: 6px;
    padding: 6px;
    font-size: 11px;
  }
`;

export const ProfessionalPrices = styled.div<SelectionProps>`
  display: grid;
  grid-template-columns: 32px 1fr auto 88px 80px 48px;
  grid-template-rows: auto;
  gap: 16px;
  align-items: center;
  width: 100%;
  min-height: 80px;
  padding: 16px;
  overflow: visible;
  box-sizing: border-box;
  margin: 0 0 8px 0;
  border: ${({ selected, theme }) =>
    selected
      ? `3px solid ${theme.colors.primaryRed400}`
      : "2px solid #F6F8FA"};
  border-radius: 8px;
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s;
  transform: ${({ selected }) => (selected ? "scale(1.005)" : "scale(1)")};

  .icon-profile {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    grid-column: 1;
    grid-row: 1;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
  }

  .name {
    font-size: 18px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText500};
    text-transform: capitalize;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.4;
    min-width: 0;
    display: flex;
    align-items: center;
    grid-column: 2 / span 4;
    grid-row: 1;
    max-width: 100%;
    overflow-wrap: anywhere;
    position: relative;
    z-index: 1;
  }

  .service {
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText500};
    text-align: left;
    white-space: nowrap;
    overflow: visible;
    text-overflow: unset;
    min-width: 88px;
    width: 88px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-column: 3;
    grid-row: 1;
    position: relative;
    z-index: 2;
    background: ${(props: any) => props.theme.colors.white};
    padding-left: 4px;
    padding-right: 4px;
  }

  .profit {
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText500};
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 4;
    grid-row: 1;
    position: relative;
    z-index: 2;
    background: ${(props: any) => props.theme.colors.white};

    &.negative {
      color: ${({ theme }) => theme.colors.interfaceDanger500};
    }
  }

  .code {
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText500};
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 5;
    grid-row: 1;
    position: relative;
    z-index: 2;
    background: ${(props: any) => props.theme.colors.white};
  }

  .contact {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
    grid-column: 6;
    grid-row: 1;
    align-self: center;
    justify-self: center;
    position: relative;
    z-index: 2;

    &:hover {
      background: ${({ theme }) => theme.colors.interfaceText100};
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 28px 1fr 70px 70px 80px 44px;
    grid-template-rows: auto auto;
    gap: 12px;
    padding: 12px;
    min-height: 70px;

    .name {
      font-size: 16px;
    }

    .service,
    .profit,
    .code {
      font-size: 14px;
    }

    .service { grid-column: 3; grid-row: 2; }
    .profit  { grid-column: 4; grid-row: 2; }
    .code    { grid-column: 5; grid-row: 2; min-width: 80px; }

    .contact {
      width: 44px;
      height: 44px;
      grid-column: 6;
      grid-row: 2;
      align-self: end;
      justify-self: end;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 24px 1fr 60px 60px 70px 40px;
    grid-template-rows: auto auto;
    gap: 8px;
    padding: 10px;
    min-height: 60px;
    box-sizing: border-box;
    margin: 0;

    .name {
      font-size: 16px;
    }

    .service,
    .profit,
    .code {
      font-size: 14px;
    }

    .service { grid-column: 3; grid-row: 2; }
    .profit  { grid-column: 4; grid-row: 2; }
    .code    { grid-column: 5; grid-row: 2; min-width: 70px; }

    .contact {
      width: 40px;
      height: 40px;
      grid-column: 6;
      grid-row: 2;
      align-self: end;
      justify-self: end;
    }
  }

  @media (max-width: 480px) {
    grid-template-columns: 20px 1fr 50px 50px 60px 36px;
    grid-template-rows: auto auto;
    gap: 6px;
    padding: 8px;
    min-height: 50px;

    .name {
      font-size: 14px;
    }

    .service,
    .profit,
    .code {
      font-size: 12px;
    }

    .service { grid-column: 3; grid-row: 2; }
    .profit  { grid-column: 4; grid-row: 2; }
    .code    { grid-column: 5; grid-row: 2; min-width: 60px; }

    .contact {
      width: 36px;
      height: 36px;
      grid-column: 6;
      grid-row: 2;
      align-self: end;
      justify-self: end;
    }
  }
`;

export const Paginate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 24px;
  margin-top: 24px;

  .pagination {
    display: flex;
    gap: 8px;
    list-style-type: none;
    margin: 0;
    padding: 0;

    .page-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background: transparent;
      border: 1px solid ${({ theme }) => theme.colors.interfaceText200};
      font-weight: 500;
      color: ${({ theme }) => theme.colors.interfaceText400};
      transition: all 0.2s;
      font-size: 12px;
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        color: ${({ theme }) => theme.colors.primaryBlue500};
        border: 1px solid ${({ theme }) => theme.colors.primaryBlue500};
      }

      &.active {
        color: ${({ theme }) => theme.colors.primaryBlue500};
        border: 1px solid ${({ theme }) => theme.colors.primaryBlue500};
        background: ${({ theme }) => theme.colors.primaryBlue50};
      }
    }

    .page-item {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .back-page,
    .next-page {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border: 1px solid ${({ theme }) => theme.colors.interfaceText200};
      cursor: pointer;
      border-radius: 4px;
      transition: all 0.2s;

      &:hover {
        color: ${({ theme }) => theme.colors.primaryBlue500};
        border: 1px solid ${({ theme }) => theme.colors.primaryBlue500};
      }
    }

    .back-link-page,
    .next-link-page {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
    }

    .page-ellipsis {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: ${({ theme }) => theme.colors.interfaceText300};
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

export const ModalContactHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 300px;
  font-size: 20px;
  font-weight: 700;
  border-bottom: 2px solid ${({ theme }) => theme.colors.interfacePure100};
  color: ${({ theme }) => theme.colors.interfaceText400};
  padding: 8px;
  padding-bottom: 24px;

  .close {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    min-width: 250px;
  }
`;

export const ModalcontactMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px;
  font-size: 18px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 16px;
    gap: 16px;
    padding: 16px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  color: ${({ theme }) => theme.colors.interfaceText300};
  font-size: 16px;
  text-align: center;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.interfaceDanger50};
  border: 1px solid ${({ theme }) => theme.colors.interfaceDanger200};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.interfaceDanger500};
  font-size: 14px;
  margin-bottom: 16px;
`;
